<template>
  <footer class="app-footer">
    <div class="container">
      <div class="row">
        <div class="footer-nav">
          <div class="footer-nav-contact">
            <p>深圳大于智能有限公司</p>
            <p>联系人：骆先生</p>
            <p>联系电话：15989499074</p>
            <p>邮箱:luoduan@aimore.com</p>
            <p>地址：深圳市南山区德赛科技大厦903A</p>
          </div>
          <img class="footer-nav-logo" src="../assets/qrcode_for_gh_55f843d0e539_258.jpg" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: #2F2E33;
}

.footer-nav {
  height: 218px;
  display: flex;
  align-items: center;

  .footer-nav-logo {
    height: 124px;
    width: 124px;
    margin-left: 20px;
    flex: 0 0 auto;
  }

  .footer-nav-contact {
    height: 124px;
    color: #EEE;
    width: 0;
    flex: 1 1 auto;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: var(--font-normal-size);
  }
}

@media screen and (max-width: 1024px) {
  .footer-nav {
    .footer-nav-contact{
      //text-align: left;
    }
  }
}
</style>